import * as React from 'react';
export const cameraSvg = React.forwardRef(function cameraSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.998 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 7.998 6Zm-3.5 2c0-1.934 1.566-3.5 3.5-3.5 1.935 0 3.5 1.566 3.5 3.5 0 1.935-1.565 3.5-3.5 3.5a3.498 3.498 0 0 1-3.5-3.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13 6.5c.547 0 1-.453 1-1 0-.547-.453-1-1-1-.547 0-1 .453-1 1 0 .547.453 1 1 1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13 3H3a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 3 13h10a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 13 3ZM3 1.5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3H3Z',
    }),
  );
});
cameraSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var camera = {
  category: 'icon',
  colorable: true,
  name: 'camera',
  svg: cameraSvg,
};
